

$(document).ready(function() {

    $('.nav-level-1 .nav-item .more').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).toggleClass("submenu-opened");
        $(this).parent().find('> ul').slideToggle('fast');
    });

    var navbar = document.getElementById("jumbotron-nav-overlay");
    // var scrollTop = document.documentElement.scrollTop;
    // console.log(scrollTop);

    window.onscroll = function() { makeMeSticky() };

    // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function makeMeSticky() {
        var sticky = $("#header").height() - 66;

        if (window.pageYOffset >= sticky) {
            navbar.classList.add("jumbotron-nav-overlay-static")
        } else {
            navbar.classList.remove("jumbotron-nav-overlay-static");
        }
    }

    // setTimeout(function() {
    //     // makeMeSticky();
    //     console.log('done');
    // }, 300);

});


